import React, { useLayoutEffect, useState } from 'react';
import './tableActions.css';

export interface TableActionsMenuProps {
    onClose: () => void;
    onAddDiscount: () => void;
    onChangeTable: () => void;
    onMergeTables: () => void;
    onDeleteOrder: () => void;
    hasPerm?: (key: string) => boolean;
    tableLabel?: string;
    anchorRef: React.RefObject<HTMLElement>;
}

const MENU_WIDTH = 264;
const GAP = 10;

const TableActionsMenu: React.FC<TableActionsMenuProps> = ({ onClose, onAddDiscount, onChangeTable, onMergeTables, onDeleteOrder, hasPerm, tableLabel, anchorRef }) => {
    const can = (key: string) => !hasPerm || hasPerm(key);
    const [pos, setPos] = useState<{ left: number; top: number; arrowLeft: number } | null>(null);

    useLayoutEffect(() => {
        const place = () => {
            const el = anchorRef.current;
            if (!el) return;
            const r = el.getBoundingClientRect();
            const margin = 8;
            // Right-align the menu to the button, clamped to the viewport.
            let left = r.right - MENU_WIDTH;
            left = Math.max(margin, Math.min(left, window.innerWidth - MENU_WIDTH - margin));
            const arrowLeft = Math.max(16, Math.min(r.left + r.width / 2 - left - 6, MENU_WIDTH - 28));
            setPos({ left, top: r.top - GAP, arrowLeft });
        };
        place();
        window.addEventListener('resize', place);
        window.addEventListener('scroll', place, true);
        return () => {
            window.removeEventListener('resize', place);
            window.removeEventListener('scroll', place, true);
        };
    }, [anchorRef]);

    if (!pos) return <div className="tav-popunder" onClick={onClose} />;

    return (
        <>
            <div className="tav-popunder" onClick={onClose} />
            <div
                className="tav-popover ps-scope"
                role="menu"
                style={{ left: pos.left, top: pos.top, transform: 'translateY(-100%)' }}
            >
                <div className="tav-popover__head">{tableLabel ? `${tableLabel} · ` : ''}open order</div>

                {can('pos-app.order.move') && (
                    <button className="tav-pop" role="menuitem" onClick={onChangeTable}>
                        <span className="tav-popicon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M2 10s.12-.85 3.64-4.36a9 9 0 0 1 12.72 0c.83.83 1.44 1.84 1.8 3.05M2 10V4M2 10h6m14 4s-.12.85-3.64 4.36a9 9 0 0 1-12.72 0A8.97 8.97 0 0 1 3.22 14M22 14v6m0-6h-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg></span>
                        Change table
                    </button>
                )}
                {can('pos-app.order.merge') && (
                    <button className="tav-pop" role="menuitem" onClick={onMergeTables}>
                        <span className="tav-popicon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M7 4H6a4 4 0 0 0 0 8h2a4 4 0 0 0 4-4m4 8h1a4 4 0 0 0 0-8h-2a4 4 0 0 0-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg></span>
                        Merge tables
                    </button>
                )}
                {can('pos-app.discount.apply') && (
                    <button className="tav-pop" role="menuitem" onClick={onAddDiscount}>
                        <span className="tav-popicon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 9h.01M15 15h.01M16 8 8 16M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg></span>
                        Add discount
                    </button>
                )}
                {can('pos-app.order.delete') && (
                    <>
                        <div className="tav-popdivider" />
                        <button className="tav-pop tav-pop--danger" role="menuitem" onClick={onDeleteOrder}>
                            <span className="tav-popicon"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 3h6M3 6h18M19 6l-.7 10.5c-.1 1.6-.16 2.4-.5 3a3 3 0 0 1-1.3 1.2c-.62.3-1.4.3-3 .3h-3c-1.58 0-2.37 0-3-.3a3 3 0 0 1-1.3-1.2c-.34-.6-.4-1.4-.5-3L5 6m5 4.5v5m4-5v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg></span>
                            Delete order
                        </button>
                    </>
                )}

                <span className="tav-popover__arrow" style={{ left: pos.arrowLeft, bottom: -7 }} />
            </div>
        </>
    );
};

export default TableActionsMenu;
